/**
 * Icones inline da pagina Minhas Pendencias — extraidos VERBATIM dos
 * <symbol> do mockup aprovado (ic-check/bolt/kebab/clock/chev/edit/link)
 * + alguns genericos do header/modal. Mantem stroke/viewBox originais.
 */
import React from "react";

const base = { viewBox: "0 0 24 24", "aria-hidden": "true" };
const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };

export const IcCheck = (p) => (
  <svg {...base} {...p}><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
);
export const IcBolt = (p) => (
  <svg {...base} {...p}><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" /></svg>
);
// Kebab: fill EXPLICITO em currentColor — sem ele o default SVG e preto (fica
// invisivel no dark mode). r=2 (era 1.5) pra os pontos nao sumirem em 16px.
export const IcKebab = (p) => (
  <svg {...base} {...p} fill="currentColor"><circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" /></svg>
);
export const IcClock = (p) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" /><path d="M12 7v5l3 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
);
export const IcChev = (p) => (
  <svg {...base} {...p}><path d="m6 9 6 6 6-6" {...stroke} /></svg>
);
export const IcEdit = (p) => (
  <svg {...base} {...p}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4z" {...stroke} /></svg>
);
export const IcLink = (p) => (
  <svg {...base} {...p}><path d="M10 13a5 5 0 0 0 7 0l4-4a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-4 4a5 5 0 0 0 7 7l1-1" {...stroke} /></svg>
);
export const IcPlus = (p) => (
  <svg {...base} {...p}><path d="M12 5v14M5 12h14" {...stroke} /></svg>
);
export const IcFilter = (p) => (
  <svg {...base} {...p}><path d="M3 6h18M7 12h10M10 18h4" {...stroke} /></svg>
);
export const IcClose = (p) => (
  <svg {...base} {...p}><path d="M18 6 6 18M6 6l12 12" {...stroke} /></svg>
);
export const IcCircle = (p) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" /></svg>
);
export const IcAlert = (p) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" /><path d="M12 8v4M12 16h.01" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
);
export const IcUser = (p) => (
  <svg {...base} {...p}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" {...stroke} /><circle cx="12" cy="7" r="4" fill="none" stroke="currentColor" strokeWidth="2" /></svg>
);
export const IcCalendar = (p) => (
  <svg {...base} {...p}><rect x="3" y="4" width="18" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="2" /><path d="M16 2v4M8 2v4M3 10h18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
);
export const IcSend = (p) => (
  <svg {...base} {...p}><path d="M22 2 11 13M22 2 15 22l-4-9-9-4 20-7z" {...stroke} /></svg>
);
